"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("@trs/config");
var _ColoredCard = _interopRequireDefault(require("./ColoredCard.style"));
var _currency = _interopRequireDefault(require("../currency"));
var _excluded = ["value", "color", "currency", "title", "textAlign"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ColoredCard = function ColoredCard(_ref) {
  var value = _ref.value,
    color = _ref.color,
    currency = _ref.currency,
    title = _ref.title,
    textAlign = _ref.textAlign,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_ColoredCard["default"], _extends({
    textAlign: textAlign,
    color: color
  }, props), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-value"
  }, /*#__PURE__*/_react["default"].createElement(_currency["default"], {
    currency: currency,
    decimals: _config.MAX_DECIMALS,
    shouldParseFloat: true
  }, value)));
};
ColoredCard.propTypes = {
  value: _propTypes["default"].number,
  color: _propTypes["default"].string,
  /** The currency symbol of the value */
  currency: _propTypes["default"].string,
  /** Alignment of text in container */
  textAlign: _propTypes["default"].oneOf(['left', 'center', 'right']),
  /** The title of the card */
  title: _propTypes["default"].string.isRequired
};
ColoredCard.defaultProps = {
  value: null,
  color: null,
  currency: 'GBP',
  textAlign: 'center'
};
var _default = exports["default"] = ColoredCard;